export default __webpack_public_path__ + "static/what-we-do-dbc007312f379987a7b9d40ea369b593.png";